// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2lA6d","consentsList":"PatientConsents_consentsList__t4WOk","consentsListEmpty":"PatientConsents_consentsListEmpty__37VrD"};